// import {KEYS} from '../constants/localStorage';
import { logoutUser } from 'app/ducks/authentication/actions';
import history from 'app/routes/history';
import _ from 'lodash';

const logoutStatuses = [401, 403];
export default function handleErrorDispatch(dispatch, error, customFunction) {
  if (logoutStatuses.indexOf(error.response.status) > -1) {
    history.listen((location) => {
      const currentLocation = location.pathname;
      dispatch(logoutUser(currentLocation));
    });
  }
  dispatch(customFunction);
}

export function handleError(error, customFunction) {
  if (_.isEmpty(error)) {
    return customFunction;
  }
  if (logoutStatuses.indexOf(error.response.status) > -1) {
    history.listen((location) => {
      const currentLocation = location.pathname;
      return logoutUser(currentLocation);
    });
  }
  return customFunction;
}
